import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from '../../../utilities/TableUtil';
import { normalColumn, numeralColumn } from '../../../components/DataTable/DataTable.js';
import * as bodyStyle from '../../../components/DataTable/ConsBodyStyle.js';

export default function P302List({ dataTable, onRowClick }) {


    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e)=>onPageChange(e,setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    onRowClick={onRowClick}
                    selectionMode="single"
                >
                    <Column sortable field="contractNo" header="สัญญา" body={(e) => normalColumn(e, 'contractNo', 'สัญญา')} style={{textAlign: 'center',width: '10%'}} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="routeNo" header="เส้นทาง" body={(e) => normalColumn(e, 'routeNo', 'เส้นทาง')} style={{ textAlign: 'center',width: '10%'}}  bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="contractor" header="บริษัทฯ" body={(e) => normalColumn(e, 'contractor', 'บริษัทฯ')} style={{ textAlign: 'center' }}   bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="pipeLength" header="ความยาวรวม(เมตร)"  body={(e) => normalColumn(e, 'pipeLength', 'ความยาวรวม')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="contractAmount" header="ค่าแรงรวม(บาท)" body={(e) => numeralColumn(e, 'contractAmount', 'ค่าแรงรวม')} style={{ textAlign: 'center', width: '10%'  }}   bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="withdrawAmount" header="ค่าแรงเบิกแล้ว(บาท)" body={(e) => numeralColumn(e, 'withdrawAmount', 'ค่าแรงเบิกแล้ว')} style={{ textAlign: 'center', width: '10%'  }}   bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="percentWithdraw" header="%"  body={(e) => normalColumn(e, 'percentWithdraw', '%')} style={{ textAlign: 'center', width: '6%' }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="materialAmount" header="ค่าท่อและวัสดุรวม(บาท)"  body={(e) => numeralColumn(e, 'materialAmount', 'ค่าท่อ/วัสดุรวม')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="materialWithdraw" header="ค่าท่อและวัสดุเบิกแล้ว (บาท)"  body={(e) => numeralColumn(e, 'materialWithdraw', 'ค่าท่อ/วัสดุเบิกแล้ว')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="percentMaterial" header="%"  body={(e) => normalColumn(e, 'percentMaterial', '%')} style={{ textAlign: 'center', width: '6%' }} bodyStyle={bodyStyle.TXT_CENTER} />

                </DataTable>
            </div>
        </div>
    )
}
